<template>
  <footer class="w-full bg-light-grey p-3">
    <!-- eslint-disable vue/no-v-html -->
    <div class="text-sm break-words text-gray-500" v-html="sanitizedFooter" />
    <!-- eslint-enable vue/no-v-html -->
  </footer>
</template>

<script setup lang="ts">
import { computed } from "vue";
import DOMPurify from "dompurify";

const { footer } = defineProps<{
  footer: string;
}>();

const sanitizedFooter = computed(() => DOMPurify.sanitize(footer));
</script>
